import React from 'react';

export const RadioBoxGroup = ({ style = { display: 'flex', marginBottom: '8px' }, children }) => {
  return <div style={style}>{children}</div>;
};
